import { FONT } from "../../../value/staticValues";
import { numberOfCommas, parseLocaleDatetime } from "../../../common/util";

import { ReactComponent as AddButtonImg } from "../../../img/ico-prefix-add.svg";
import { ReactComponent as AddButtonActiveImg } from "../../../img/ico-prefix-add-white.svg";


import { DropdownType } from "../../base/CustomDropdown";
import { ListActionMenu, ListTableHeader } from "../../base/table/listTableType";
import { TABLE_ACTION_MENU_TYPE, TABLE_BUTTON_TYPE } from "../../../value/type";

import i18n from "../../../lang/base";
import ProductAdd from "./ProductAdd";
import ProductUpdate from "./ProductUpdate";

export interface ProductData {
    product_id: string;
    product_name: string;
    product_description: string | undefined;
    product_type_code: string;
    base_price: number;
    create_ts: string;
    update_ts: string;
}


export const initProductData = {
    product_id: "",
    product_name: "",
    product_description: "",
    product_type_code: "",
    base_price: 0,
    create_ts: "",
    update_ts: ""
}

export const actionMenus:ListActionMenu[] = [
    {
        id: 1,
        name: i18n.t("SERVICE_PRODUCT_ADD_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.PUSH_WITH_ICON,
            code: "PRODUCT_ADD",
            imgComponent: <AddButtonImg/> ,
            activeImgComponent: <AddButtonActiveImg />,
            inactiveImgComponent: <AddButtonImg style={{filter: "opacity(0.5) grayscale(0.5)"}}/>,
        },
    },
    {
        id: 2,
        name: i18n.t("DELETE_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.CANCEL,
            code: "PRODUCT_DELETE",
        },
    }
]

export const tableHeaders:ListTableHeader[] = [
    {
        Header: i18n.t("SERVICE_PRODUCT_NAME_TEXT"),
        accessor: "product_name",
        disableSortBy: false,
        style: {
            width: "200px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value}</div>)
    },
    {
        Header: i18n.t("SERVICE_PRODUCT_TYPE_TEXT"),
        accessor: "product_type_code",
        disableSortBy: true,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{
                display: "flex", alignItems: "center", justifyContent: "center",
                width: 50, height: 20,
                paddingLeft: 10, paddingRight: 10,
                borderRadius: 10,
                backgroundColor: value === "RDS" ? "#66abe8" : value === "VDI" ? "#92ca6e" : "#b6bfce",
                fontFamily: FONT.REGULAR,
                fontSize: 12,
                color: "#fff"
            }}>
                {
                    value === "RDS" ? "RDS"
                    : value === "VDI" ? "VDI"
                    : "None"
                }
            </div>
        )
    },
    {
        Header: i18n.t("SERVICE_PRODUCT_PRICE_TEXT"),
        accessor: "base_price",
        disableSortBy: true,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer,...className.purpleText}}>
            {
                value > 0 ? numberOfCommas(value) + " 원" : "가격 협의"
            }
        </div>)
    },
    {
        Header: i18n.t("SERVICE_PRODUCT_DESCRIPTION_TEXT"),
        accessor: "product_description",
        disableSortBy: false,
        style: {
            
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value}</div>)
    },
    
    {
        Header: i18n.t("UPDATE_DATE_TEXT"),
        accessor: "update_ts",
        disableSortBy: false,
        style: {
            width: "130px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer}}>{value ? parseLocaleDatetime(value) : ""}</div>)
    },
    {
        Header: i18n.t("CREATE_DATE_TEXT"),
        accessor: "create_ts",
        disableSortBy: false,
        style: {
            width: "130px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer,...className.dateContainer}}>{value ? parseLocaleDatetime(value) : ""}</div>)
    },
]


export const productAddModalContent = {
    title: i18n.t("SERVICE_PRODUCT_CREATE_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("CREATE_TEXT")
        },
    ],
    innerComponent: <ProductAdd />,
}

export const productUpdateModalContent = {
    title: i18n.t("SERVICE_PRODUCT_UPDATE_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("UPDATE_SAVE_TEXT")
        },
    ],
    innerComponent: <ProductUpdate />,
}

export const ProductTypeDropdownItem:DropdownType[] = [
    {
        value: "RDS",
        label: "RDS"
    },
    {
        value: "VDI",
        label: "VDI"
    }
]




const className = {
    normalTextContainer: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333",
        overflow: "hidden"
    },
    statusImg: {
        marginRight: 3
    },
    dateContainer: {
        color: "#9ea0a5",
    },
    resourceContainer: {
        color: "#0853fb"
    },
    countContainer: {
        color: "#3a8344"
    },
    purpleText: {
        color: "#7066f1"
    },
    greenText: {
        color: "#3a8344"
    }
}